/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { SysqueElectricalState } from 'libs/sysque/toolbelt/feature/src/lib/models/sysque-electrical-state';
import { Observable } from 'rxjs';

/**
 * Represents the interface for the SysQue Gauge Facade.
 */
export interface ISysQueGaugeFacade {
  /**
   * Retrieves the SysQue Connect Fitting Variables.
   * @returns A promise that resolves to an array of strings.
   */
  getSysQueConnectFittingVariables(): Promise<string[]>;

  /**
   * Initializes the SysQue Gauge.
   */
  initializeSysQueGauge(): Observable<any>;

  /**
   * Rotates the SysQue Connect.
   * @param angle - The angle to rotate the SysQue Connect.
   */
  rotateSysQueConnect(angle: string): Observable<any>;

  /**
   * Retrieves the current system state.
   * @returns The current SysqueElectricalState.
   */
  getSystemState(): SysqueElectricalState;

  /**
   * Updates the value in local storage.
   * @param key - The key to update in local storage.
   * @param value - The new value to set.
   */
  updateLocalStorage(key: string, value: any): void;

  /**
   * Closes the window.
   */
  closeWindow(): void;
  
   /**
   * Retrieves the system name of the selected element.
   * @returns The selected element system name.
   */
   getSelectedElementSystemName(): Promise<string>

   updateDockableState(state: SysqueElectricalState): void;

   getSelectedSystemName(): string;
}

export const SYSQUE_GAUGE_FACADE_TOKEN = new InjectionToken<ISysQueGaugeFacade>('SYSQUE_GAUGE_FACADE_TOKEN');
